import { defineComponent as N, h as d, withDirectives as x, Transition as L, ref as H, inject as k, provide as D, toRef as C, computed as g } from "vue";
import { dialogProviderInjectionKey as z } from "./highrise1164.mjs";
import I from "./highrise1165.mjs";
import { modalProviderInjectionKey as T, modalInjectionKey as U } from "./highrise1166.mjs";
import { presetPropsKeys as _, presetProps as K } from "./highrise1167.mjs";
import V from "./highrise1168.mjs";
import $ from "./highrise718.mjs";
import W from "./highrise641.mjs";
import { warnOnce as f } from "./highrise1064.mjs";
import q from "./highrise1053.mjs";
import y from "./highrise984.mjs";
import G from "./highrise633.mjs";
import J from "./highrise631.mjs";
import Q from "./highrise635.mjs";
import { useIsComposing as X } from "./highrise1092.mjs";
import { useThemeClass as Y } from "./highrise1062.mjs";
import { keep as Z } from "./highrise1097.mjs";
import ee from "./highrise1003.mjs";
import { call as u } from "./highrise1077.mjs";
import { getPreciseEventTarget as oe } from "./highrise1159.mjs";
import { eventEffectNotPerformed as te } from "./highrise1091.mjs";
const ne = Object.assign(Object.assign(Object.assign(Object.assign({}, y.props), {
  show: Boolean,
  unstableShowMask: {
    type: Boolean,
    default: !0
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  preset: String,
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  transformOrigin: {
    type: String,
    default: "mouse"
  },
  zIndex: Number,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  trapFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  }
}), K), {
  draggable: [Boolean, Object],
  // events
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  // private
  internalDialog: Boolean,
  internalModal: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
}), Fe = N({
  name: "Modal",
  inheritAttrs: !1,
  props: ne,
  slots: Object,
  setup(o) {
    process.env.NODE_ENV !== "production" && (o.onHide && f("modal", "`on-hide` is deprecated."), o.onAfterHide && f("modal", "`on-after-hide` is deprecated, please use `on-after-leave` instead."), o.onBeforeHide && f("modal", "`on-before-hide` is deprecated, please use `on-before-leave` instead."), o.overlayStyle && f("modal", "`overlay-style` is deprecated, please use `style` instead."));
    const s = H(null), {
      mergedClsPrefixRef: a,
      namespaceRef: r,
      inlineThemeDisabled: m
    } = q(o), h = y("Modal", "-modal", V, ee, o, a), b = G(64), P = J(), v = Q(), B = o.internalDialog ? k(z, null) : null, R = o.internalModal ? k(T, null) : null, F = X();
    function i(e) {
      const {
        onUpdateShow: t,
        "onUpdate:show": n,
        onHide: c
      } = o;
      t && u(t, e), n && u(n, e), c && !e && c(e);
    }
    function S() {
      const {
        onClose: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function w() {
      const {
        onPositiveClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function A() {
      const {
        onNegativeClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function M() {
      const {
        onBeforeLeave: e,
        onBeforeHide: t
      } = o;
      e && u(e), t && t();
    }
    function O() {
      const {
        onAfterLeave: e,
        onAfterHide: t
      } = o;
      e && u(e), t && t();
    }
    function E(e) {
      var t;
      const {
        onMaskClick: n
      } = o;
      n && n(e), o.maskClosable && !((t = s.value) === null || t === void 0) && t.contains(oe(e)) && i(!1);
    }
    function j(e) {
      var t;
      (t = o.onEsc) === null || t === void 0 || t.call(o), o.show && o.closeOnEsc && te(e) && (F.value || i(!1));
    }
    D(U, {
      getMousePosition: () => {
        const e = B || R;
        if (e) {
          const {
            clickedRef: t,
            clickedPositionRef: n
          } = e;
          if (t.value && n.value)
            return n.value;
        }
        return b.value ? P.value : null;
      },
      mergedClsPrefixRef: a,
      mergedThemeRef: h,
      isMountedRef: v,
      appearRef: C(o, "internalAppear"),
      transformOriginRef: C(o, "transformOrigin")
    });
    const p = g(() => {
      const {
        common: {
          cubicBezierEaseOut: e
        },
        self: {
          boxShadow: t,
          color: n,
          textColor: c
        }
      } = h.value;
      return {
        "--n-bezier-ease-out": e,
        "--n-box-shadow": t,
        "--n-color": n,
        "--n-text-color": c
      };
    }), l = m ? Y("theme-class", void 0, p, o) : void 0;
    return {
      mergedClsPrefix: a,
      namespace: r,
      isMounted: v,
      containerRef: s,
      presetProps: g(() => Z(o, _)),
      handleEsc: j,
      handleAfterLeave: O,
      handleClickoutside: E,
      handleBeforeLeave: M,
      doUpdateShow: i,
      handleNegativeClick: A,
      handlePositiveClick: w,
      handleCloseClick: S,
      cssVars: m ? void 0 : p,
      themeClass: l == null ? void 0 : l.themeClass,
      onRender: l == null ? void 0 : l.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: o
    } = this;
    return d($, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var s;
        (s = this.onRender) === null || s === void 0 || s.call(this);
        const {
          unstableShowMask: a
        } = this;
        return x(d("div", {
          role: "none",
          ref: "containerRef",
          class: [`${o}-modal-container`, this.themeClass, this.namespace],
          style: this.cssVars
        }, d(I, Object.assign({
          style: this.overlayStyle
        }, this.$attrs, {
          ref: "bodyWrapper",
          displayDirective: this.displayDirective,
          show: this.show,
          preset: this.preset,
          autoFocus: this.autoFocus,
          trapFocus: this.trapFocus,
          draggable: this.draggable,
          blockScroll: this.blockScroll
        }, this.presetProps, {
          onEsc: this.handleEsc,
          onClose: this.handleCloseClick,
          onNegativeClick: this.handleNegativeClick,
          onPositiveClick: this.handlePositiveClick,
          onBeforeLeave: this.handleBeforeLeave,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave,
          onClickoutside: a ? void 0 : this.handleClickoutside,
          renderMask: a ? () => {
            var r;
            return d(L, {
              name: "fade-in-transition",
              key: "mask",
              appear: (r = this.internalAppear) !== null && r !== void 0 ? r : this.isMounted
            }, {
              default: () => this.show ? d("div", {
                "aria-hidden": !0,
                ref: "containerRef",
                class: `${o}-modal-mask`,
                onClick: this.handleClickoutside
              }) : null
            });
          } : void 0
        }), this.$slots)), [[W, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
export {
  Fe as default,
  ne as modalProps
};
